import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import React from 'react';

// 导入动画组件和样式
import { AnimatedGrid } from '../AnimatedSection';
import '../AnimatedSection/scroll-animations.scss';
import CommonTitle from '../CommonTitle';
import EcoVideo from 'eco-design/base/eco-video';

interface EssentialsProps {
    pageType: 'ultra' | 'max';
}

const Essentials: React.FC<EssentialsProps> = ({ pageType }: EssentialsProps = { pageType: 'max' }) => {
    const { locale } = getLocal();
    const { t } = useLang('Essentials');

    const videoLink =
        pageType === 'ultra'
            ? 'https://websiteoss.ecoflow.com/upload/video/1759044621248/D3U.mp4'
            : 'https://websiteoss.ecoflow.com/upload/video/1759041679075/D3M.mp4';

    const posterLink =
        pageType === 'ultra'
            ? 'https://websiteoss.ecoflow.com/figma-uploads/1758871347956-nb02mu-compressed-D3U%2B_%E5%AE%98%E7%BD%91%E5%AF%B9%E6%AF%94_HD_Clean_Final_0924%201.jpg'
            : 'https://websiteoss.ecoflow.com/figma-uploads/1758871263277-2w80f6-compressed-D3M%2B_%E5%AE%98%E7%BD%91%E5%AF%B9%E6%AF%94_HD_Clean_Final_0924%201.jpg';
    return (
        <div className={styles.Essentials + ' GtmModuleData-section'} data-section-id="d3m-essentials">
            <CommonTitle
                title={t('title')}
                desc={t.rich('desc', {
                    sup: (text: string) => <sup>{text}</sup>,
                })}
            />

            <EcoVideo pc={videoLink} poster={posterLink} autoPlay loop />

            {/* <AnimatedGrid
                variant="rotateIn"
                options={{ delay: 200, stagger: 0.15, threshold: 0.2 }}
                className="img-list card-list pc-only"
                itemClassName="card-item-animated"
            >
                <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1757405271533-r4gn74-compressed-Frame%201612708123.jpg" isOpenLazy={false} />
                <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1757405294282-ew11ba-compressed-image%205156065.jpg" isOpenLazy={false} />
            </AnimatedGrid> */}

            {/* <EcoSpace hPc="160px" /> */}
        </div>
    );
};

export default Essentials;
